class IrTop {
  constructor() {
    const swiperEl = document.querySelector('.js-ir-news-swiper');
    if(swiperEl){
      this.loadedSwiper(swiperEl);
      this.toggleSwiper(swiperEl);
    }
  }

  initSwiper(item) {
    new Swiper(item, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      navigation: {
        prevEl: item.querySelector('.js-ir-news-swiper__prev'),
        nextEl: item.querySelector('.js-ir-news-swiper__next'),
      }
    });
    item.style.opacity = 1;
  }

  loadedSwiper(swiperEl){
    const mm = gsap.matchMedia();
    this.onAdded('.js-ir-news-swiper .swiper-slide',()=>{
      mm.add('(max-width: 769px)', () => {
        this.initSwiper(swiperEl);
      });
    })
  }

  toggleSwiper(swiperEl){
    this.onAdded('.js-ir-news-swiper .swiper-slide',()=>{
      const buttonEls = document.querySelectorAll('.c-tab-list__button');
      buttonEls.forEach(button => {
        button.addEventListener('click',()=>{
          swiperEl.style.opacity = 0;
          setTimeout(()=>{
            this.initSwiper(swiperEl);
          },200)
        })
      })
    })
  }

  onAdded(selector, cb) {
    const found = document.querySelector(selector);
    if (found) return cb(found); 

    const mo = new MutationObserver((mutations, obs) => {
      const el = document.querySelector(selector);
      if (el) {
        obs.disconnect();
        cb(el);
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
}
